// extracted by mini-css-extract-plugin
export var disabled = "component-module--disabled--4a9e1";
export var fullWidth = "component-module--fullWidth--d6668";
export var iconHolder = "component-module--iconHolder--03056";
export var invisible = "component-module--invisible--431d1";
export var main = "component-module--main--dfa3c";
export var outlined = "component-module--outlined--c3489";
export var primary = "component-module--primary--63398";
export var primaryOutlined = "component-module--primaryOutlined--7e0bb";
export var rightIcon = "component-module--rightIcon--7e520";
export var secondary = "component-module--secondary--2eb1c";
export var slim = "component-module--slim--e64e3";